// istanbul ignore file
import ProgressCircular from './ProgressCircular.js';
import ProgressLogo from './ProgressLogo.js';
const Progress = { Logo: ProgressLogo, Circular: ProgressCircular };
// eslint-disable-next-line import/no-default-export
export default Progress;
//# sourceMappingURL=index.js.map